import React from 'react'

import useResearcher from './useResearcher'
import useFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import { menuTab } from '../../../../../../constants/constants'
import CloseProjectResearcher from '../../../page/closeProjectResearcher/closeProjectResearcher'
import ResultOfConsiderPrevious from '../../../page/resultOfConsiderPrevious/closeProject/resultOfConsiderPrevious'
import ResultOfConsider from '../../../page/resultOfConsider/closeProject/resultOfConsider'

type ResearcherViewType = ResearcherType & ReturnType<typeof useResearcher>
const ResearcherView: React.FC<ResearcherViewType> = (props) => {
    const { projectData } = props
    const folderAndTabStore = useFolderAndTabStore()
    const renderPage = () => {
        switch (folderAndTabStore?.tabSelected?.id) {
            case menuTab.tab21.id:
            case menuTab.tab25.id:
                return <CloseProjectResearcher />
            case menuTab.tab23.id:
                return <ResultOfConsider projectData={projectData ?? undefined} />
            case menuTab.tab26.id:
                return (
                    <>
                        <ResultOfConsiderPrevious
                            projectID={projectData?.projectID ?? 0}
                            submittedID={projectData?.aroundSubmittedIDInfo.previousSubmittedID ?? 0}
                        />
                    </>
                )
            default:
                return <></>
        }
    }
    return renderPage()
}

export type ResearcherType = {
    projectMode: 'CREATE' | 'EDIT'
    callbackSaveComplete?: (resStatus: number, isDraft: boolean) => void
}
const Researcher: React.FC<ResearcherType> = (props) => {
    const researcher = useResearcher(props)
    return <ResearcherView {...props} {...researcher} />
}
export default Researcher
